<template>
    <div class="st-card st-card--full">
        <div class="st-card-header">
            <div class="st-card-icon">
                <i class="fal fa-key"></i>
            </div>
            <div class="flex-1">
                <h2 class="st-card-title">{{ $t('companies.settings.export.title') }}</h2>
            </div>
            <button class="st-btn st-btn--primary" @click="generateNewToken()">
                <i class="fal fa-plus" style="color: #fff !important;"></i>
                {{ $t('companies.settings.export.token_creation') }}
            </button>
        </div>

        <div class="st-card-body" v-if="tokens.length > 0">
            <BmvTable :columns="tokenColumns" :data="tokens">
                <template #cell-token="{ row }">
                    <code class="st-token-code">{{ row.token }}</code>
                </template>
                <template #cell-last_used="{ row }">
                    {{ row.last_used ? formatDate(row.last_used) : '—' }}
                </template>
            </BmvTable>
        </div>
        <div v-else class="st-card-body">
            <div class="st-empty">
                <i class="fal fa-key"></i>
                <span>Aucun token</span>
            </div>
        </div>
    </div>
</template>

<script>
import BmvTable from '@/components/UI/BmvTable'
import { TokenExportService } from '@/services/tokens'

export default {
    name: 'SettingsTokens',
    components: { BmvTable },
    props: {
        companyId: {
            type: [Number, String],
            required: true
        }
    },
    data() {
        return {
            tokens: [],
            tokenColumns: [
                { field: 'token', label: 'Token' },
                { field: 'last_used', label: 'Dernière utilisation' }
            ]
        }
    },
    async created() {
        await TokenExportService.list(this.companyId).then(({ data }) => {
            this.tokens = data
        })
    },
    methods: {
        formatDate(dateString) {
            const date = new Date(dateString)
            return date.toLocaleString('fr-FR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            })
        },
        async generateNewToken() {
            await TokenExportService.generateToken(this.companyId).then(
                ({ data }) => {
                    this.$swal.fire(
                        this.$t('companies.settings.export.generated'),
                        this.$t('companies.settings.export.generated_correctly') + `<small>${data.token}</small>`,
                        'success'
                    )
                    this.tokens.push(data)
                }
            )
        }
    }
}
</script>
